import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import no from 'vee-validate/dist/locale/nb_NO.js'

import Root from './Root'

import store from './store'
import router from './router'
import httpPlugin from './plugins/http'
import eventbus from './plugins/eventbus'
import lodash from 'lodash'

// jQuery and Bootstrap includes
require('./includes')

/**
* Make $http avaible to all components
* Send store and router to httpPlugin (injection)
*/
Vue.use(httpPlugin, { store, router })

/**
* Make $bus avaible to all components
*/
Vue.use(eventbus)

/**
 * For validations
 */
Vue.use(VeeValidate)
Validator.localize('nb_NO', no)

/**
 * TODO: Add global filters in it's own file
 */
Vue.filter('priceToLocal', (price) => {
  return price.replace('.', ',').replace(',00', ',-')
})

// Effortlessly keep vue-router and vuex store in sync.
sync(store, router) // https://github.com/vuejs/vuex-router-sync/tree/next

/* eslint-disable no-new */
new Vue({
  store, // injects the Store into all components
  router, // make Router work with the application
  el: '#app',
  render: h => h(Root),
})

// Now, bind lodash to Vue instance as read-only
Object.defineProperty(Vue.prototype, '$_', { value: lodash })



// WEBPACK FOOTER //
// ./src/main.js